import { render, staticRenderFns } from "./UpdateTransfer.vue?vue&type=template&id=472b6ade"
import script from "./UpdateTransfer.vue?vue&type=script&lang=js"
export * from "./UpdateTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports